<div
  class="shade-host"
>
  <div
    #shade
    class="shade-bkgd"
  ></div>

  <div
    class="drawer-bottom"
    [ngStyle]="{
      'z-index': cssZIndex,
      'margin-top': cssMarginTop,
      'height': cssHeight
    }"
  >
    <div
      class="outer-container"
      [class.loading]="loading"
    >
      @if (loading) {
        <motn-spinner [centered]="true"></motn-spinner>
      } @else {
        <ng-content></ng-content>
      }
    </div>

    <motn-tile-history-viewport-buffer></motn-tile-history-viewport-buffer>
  </div>
</div>
